import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { getUnreadCount } from '../api/notifications';
import useNotificationStream from '../hooks/useNotificationStream';

const NotificationsBell = () => {
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);

  const fetchUnread = useCallback(async () => {
    try {
      const data = await getUnreadCount();
      setUnread(data.unread || 0);
    } catch { /* silent */ }
  }, []);

  useEffect(() => {
    fetchUnread();
    // 🟥 SSE — polling de fallback cada 60s (era 30s).
    // El stream SSE empuja eventos en tiempo real; el polling solo cubre
    // casos de reconexión perdida y proxies muy agresivos.
    const interval = setInterval(fetchUnread, 60000);
    return () => clearInterval(interval);
  }, [fetchUnread]);

  // 🟥 MINI-SPRINT SSE — Listener real-time. Cada vez que llega una
  // notificación nueva, refrescamos el contador. Best-effort: si el
  // navegador no soporta EventSource, el polling se encarga.
  useNotificationStream({
    enabled: true,
    onNotification: () => { fetchUnread(); },
  });

  return (
    <button
      onClick={() => navigate('/dashboard/notifications')}
      className="relative p-1.5 text-slate-400 hover:text-white hover:bg-slate-700/50 rounded-lg transition-colors"
      data-testid="notifications-bell"
    >
      <Bell className="w-4 h-4" />
      {unread > 0 && (
        <span
          className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 flex items-center justify-center text-[10px] font-bold text-white bg-red-500 rounded-full px-1"
          data-testid="notifications-badge"
        >
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </button>
  );
};

export default NotificationsBell;
